/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

import {CHARTS_GAP} from '../../const';

export const Root = styled(Box)(() => ({
  height: CHARTS_GAP,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'flex-end',
  marginLeft: -7,
}));

export const LabelCard = styled(Box)(({theme}) => ({
  height: 18,
  padding: theme.spacing(0.5, 1),
  borderRadius: '0px 8px 8px 0px',
  background: '#2D2E32',
  width: 'max-content',
}));

interface LabelTextProps {
  color: string;
  showType: boolean;
}

export const LabelText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'showType',
})<LabelTextProps>(({color, showType, theme}) => ({
  color: showType ? '#FAFBFE' : color,
  fontSize: '12px',
  lineHeight: '14px',

  span: {
    color,
    fontSize: '12px',
    lineHeight: '14px',
    marginRight: theme.spacing(1),
  },
}));
